import { formatTemplate } from '../formatter';
export function defaultValidationMessageFormatter(message, injectOptons) {
    if (message && injectOptons) {
        return formatTemplate(message, injectOptons);
    }
    return message;
}
export function defaultValidationMessageReportFormatter(_) {
    return undefined;
}
